import { frontendURL } from '../../../helper/URLHelper';
import ScheduledMessagesPage from './pages/ScheduledMessagesPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: 'scheduled_messages',
};

const scheduledMessagesRoutes = [
  {
    path: frontendURL('accounts/:accountId/scheduled_messages'),
    component: ScheduledMessagesPage,
    meta,
    name: 'scheduled_messages_index',
  },
];

export default {
  routes: scheduledMessagesRoutes,
};
